export const jwt = {
  save: (newJwt: string) => {
    localStorage.setItem('adminJwt', newJwt);
  },
  load: (): string | null => {
    return localStorage.getItem('adminJwt');
  },
};
